/**
 * Fake dropdown to replace the Tabs' header
 */
export default class SimpleTabsFakeDropdown {
  constructor(simpleTabsContainerEl) {
    const self = this;

    this._activeState = false;

    // Creates and stores fake dropdown element so that we can add events to it
    this._fakeDropdownElement = this.createFakeDropdownElement( simpleTabsContainerEl );

    // Event :: dropdown toggle
    this._fakeDropdownElement.addEventListener('click', this.toggleDropdown.bind(this));

    // Loops through all tabs to attach events
    this._fakeDropdownElement.nextElementSibling.querySelectorAll('li').forEach(node => {

      // Updates dropdown current selection with the active tab's name
      if ( node.classList.contains('active') ) {
        self.updatesCurrentDropdownOptionLabel( node );
      }

      // Event :: tab option selection
      node.addEventListener('click', self.selectTabOption.bind(self));
    });
  }

  /**
   * The fake dropdown element needs to be place immediately before .simple-tabs__header element
   */
  createFakeDropdownElement(simpleTabsContainerEl) {
    let divNode = document.createElement('div');
    divNode.classList.add('simple-tabs__mobile-dropdown', 'js-simple-tabs-mobile-dropdown');

    simpleTabsContainerEl.insertBefore(divNode, simpleTabsContainerEl.firstChild);

    return divNode;
  }

  /**
   * Note:
   * When fetching the text from the DOM element, .textContent should be used to avoid copying
   * the rendered version of the text, which could include text-transform properties for example.
   *
   * Read more:
   * - https://stackoverflow.com/questions/35213147/difference-between-textcontent-vs-innertext/35213639#35213639
   */
  updatesCurrentDropdownOptionLabel(tabEl) {
    this._fakeDropdownElement.innerText = tabEl.textContent;
  }

  toggleDropdown(el) {
    if ( this._activeState ) {
      this.collapseDropdown( el.currentTarget );
    } else {
      this.expandDropdown( el.currentTarget );
    }
  }

  expandDropdown(el) {
    el.classList.add('expand');
    this._activeState = true;
  }

  collapseDropdown(el) {
    el.classList.remove('expand');
    this._activeState = false;
  }

  selectTabOption(el) {
    this.updatesCurrentDropdownOptionLabel( el.currentTarget );

    this.collapseDropdown( this._fakeDropdownElement );
  }
}